<template>
  <el-select v-model="value" multiple placeholder="All">
    <el-option
      v-for="conversionType in conversionTypes"
      :key="conversionType"
      :class="{
        'conversion-type-option--with-stats': hasStats(conversionType)
      }"
      :label="conversionType"
      :value="conversionType"
    />
  </el-select>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

const conversionTypes = Array.from({ length: 10 }, (_, index) => 101 + index)

export default defineComponent({
  name: 'ConversionTypeSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    statConversionTypes: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = computed({
      get: () => props.modelValue,
      set: (newValue: number[]) => {
        context.emit('update:modelValue', newValue)
      }
    })

    const statConversionTypes = computed(() =>
      new Set(props.statConversionTypes)
    )
    const hasStats = (conversionType: number) => {
      return statConversionTypes.value.has(conversionType)
    }

    return { conversionTypes, value, hasStats }
  }
})
</script>

<style lang="scss" scoped>
.conversion-type-option--with-stats {
  color: #11845b;
  font-weight: 600;
}
</style>
